export const routePermissions = {
  "/": ["Direktorat Peningkatan Kapasitas", "Direktorat Vokasi", "*"],

  "/training-catalog": ["Direktorat Peningkatan Kapasitas", "*"],
  "/training-verification": ["Direktorat Peningkatan Kapasitas", "*"],

  "/institutional-verification": ["Direktorat Vokasi", "*"],

  "/faq": ["Direktorat Peningkatan Kapasitas", "Direktorat Vokasi", "*"],

  "/help-center": [
    "Direktorat Peningkatan Kapasitas",
    "Direktorat Vokasi",
    "*",
  ],

  "/testimony": ["Direktorat Peningkatan Kapasitas", "Direktorat Vokasi", "*"],

  "/user": ["Direktorat Vokasi", "Direktorat Peningkatan Kapasitas", "*"],

  "/master-data": [
    "Direktorat Vokasi",
    "Direktorat Peningkatan Kapasitas",
    "*",
  ],

  "/setting": ["*"],

  "/history-log": [
    "Direktorat Vokasi",
    "Direktorat Peningkatan Kapasitas",
    "*",
  ],

  "/profile": ["Direktorat Vokasi", "Direktorat Peningkatan Kapasitas", "*"],
};
